module.exports = __webpack_public_path__ + "img/10.ad408486.png";